import { useEffect } from "react";
import { Contract, Status } from "../../models/ContractTypes";
import { SharepointStatus } from "../../models/SharePointTypes";
import { StoreAddContractStatus, StoreContractStatus } from "../../hooks/ContractStore";
import { StoreUpdateWorkspaceStatus } from "../../hooks/SharePointStore";

export interface StatusServiceResult {
  // Données des stores
  searchStatus: (projectId: number) => Promise<void>;
  responseStatus: any;
  addStatus: (projectId: number, status: Status) => Promise<void>;
  responseAddedItem: any;
  updateWorkspaceStatus: (projectId: number, status: SharepointStatus) => Promise<void>;
  responseUpdateWorkspaceStatus: any;
  errorUpdateWorkspaceStatus: any;
}

export function useStatusService (choosenContract: Contract[], responseCodeSp: any, workspaceStatus:any  ): StatusServiceResult {
  const choosenContractOne: Contract = choosenContract[0];
  
  const { searchStatus, responseStatus } = StoreContractStatus(); // local status
  const { addStatus, responseAddedItem } = StoreAddContractStatus(); // update/create status to ged database
  const { updateWorkspaceStatus, responseUpdateWorkspaceStatus, errorUpdateWorkspaceStatus } = StoreUpdateWorkspaceStatus(); // mise à jour du statut de l'espace documentaire à la fois dans la BDD de la ged et dans la liste sharepoint

  useEffect(() => {
    if (choosenContractOne?.projectId) {
      searchStatus(choosenContractOne.projectId);
    }
  }, [choosenContractOne, responseAddedItem]);

  useEffect(() => {
      updateWorkspace();
  }, [workspaceStatus]);


  // Fonction pour mettre à jour le statut d'un workspace
  function updateWorkspace() {
    if (responseCodeSp?.code_sp != null && workspaceStatus) {
      let sharePointStatus = null;

      switch (workspaceStatus) {
        case Status.ARCHIVER:
          sharePointStatus = SharepointStatus.TO_ARCHIVE;
          break;
        case Status.RESTAURER:
          sharePointStatus = SharepointStatus.TO_RESTORE;
          break;
      }

      if (sharePointStatus) {
        updateWorkspaceStatus(choosenContractOne.projectId, sharePointStatus); // Envoi vers SharePoint
        if(responseUpdateWorkspaceStatus!= null){
          addStatus(choosenContractOne.projectId, workspaceStatus); // Envoi vers la base de données locale GED
        }
       
      }
    }
  };


  return {
    // Données des stores
    searchStatus,
    responseStatus,
    addStatus,
    responseAddedItem,
    updateWorkspaceStatus,
    responseUpdateWorkspaceStatus,
    errorUpdateWorkspaceStatus,
  };
};

